<script lang="ts" setup>
defineSlots<{
  default: () => VNode[];
}>();
</script>

<template>
  <blockquote class="contentProseBlockquote">
    <slot />
  </blockquote>
</template>

<style lang="scss">
.contentProseBlockquote {
  padding: 16px;
  background: #8583ba;
  border-radius: 10px;
  margin: 0 0 40px;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.2px;
  color: #ffffff;

  * {
    margin: 0 !important;
  }

  // Ссылки внутри фиолетовой плашки — белые с подчёркиванием.
  // Скоуп строго по .contentProseBlockquote, чтобы не задеть цвет ссылок
  // (.contentProseA) в остальных местах сайта.
  a {
    color: #ffffff;
    text-decoration: underline;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>
